/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefApiKeyData } from '../../models/api-def-api-key-data';

export interface OrganizationsListApiKeys$Params {
  organizationId: string;
}

export function organizationsListApiKeys(http: HttpClient, rootUrl: string, params: OrganizationsListApiKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiDefApiKeyData>>> {
  const rb = new RequestBuilder(rootUrl, organizationsListApiKeys.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApiDefApiKeyData>>;
    })
  );
}

organizationsListApiKeys.PATH = '/organizations/{organizationId}/api-keys';
